/**
 * Hard-coded UUIDs for seeded rows.
 *
 * THESE MUST NEVER BE `crypto.randomUUID()`.
 *
 * Both devices seed independently -- the iPad may well launch before you have
 * pasted the sync token, so it cannot pull, sees an empty database, and seeds.
 * With random ids you would then own two "Work" categories with different ids,
 * both valid, and last-write-wins cannot merge them because they are distinct
 * rows. Nothing can repair that afterwards.
 *
 * With fixed ids the iPad's "Work" and the iPhone's "Work" are the SAME row,
 * so sync collapses them automatically. See 02-data-model.md section 11.
 *
 * Format: valid UUID v4 shape, with a readable tail. Never renumber an
 * existing constant -- doing so orphans every entry that points at it.
 */

const CAT = (n: number) => `00000000-0000-4000-8000-c00000000${String(n).padStart(3, '0')}`
const TYPE = (n: number) => `00000000-0000-4000-8000-e00000000${String(n).padStart(3, '0')}`
const GROUP = (n: number) => `00000000-0000-4000-8000-a00000000${String(n).padStart(3, '0')}`

export const SEED_CATEGORY_IDS = {
  rest: CAT(1),
  work: CAT(2),
  health: CAT(3),
  learn: CAT(4),
  life: CAT(5),
  leisure: CAT(6),
} as const

export const SEED_TYPE_IDS = {
  sleep: TYPE(1),
  nap: TYPE(2),
  relax: TYPE(3),

  focus: TYPE(10),
  meeting: TYPE(11),
  email: TYPE(12),
  admin: TYPE(13),

  exercise: TYPE(20),
  walk: TYPE(21),
  cook: TYPE(22),
  eat: TYPE(23),

  read: TYPE(30),
  study: TYPE(31),
  practice: TYPE(32),

  commute: TYPE(40),
  chores: TYPE(41),
  family: TYPE(42),
  social: TYPE(43),

  games: TYPE(50),
  video: TYPE(51),
  music: TYPE(52),
  browse: TYPE(53),
} as const

export const SEED_GROUP_IDS = {
  projects: GROUP(1),
} as const
